import { Currency, CurrencyDetails } from "fond/types/currency";
import { SystemOfMeasurement } from "fond/types/project";

import { SelectProps } from "./SelectField";

export const CURRENCY_OPTIONS: SelectProps["options"] = Currency.map((currency) => ({
  value: currency,
  displayValue: `${CurrencyDetails[currency].Name} (${CurrencyDetails[currency].Symbol})`,
}));

export const SYSTEM_OF_MEASUREMENT_OPTIONS: SelectProps["options"] = SystemOfMeasurement.map((value) => ({
  value,
  displayValue: value === "imperial" ? "Imperial" : "Metric",
}));
